
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { useCartStore } from '../../store/cartStore';
import { useState, useEffect } from 'react';
import { supabase } from '../../lib/supabase';

export function Header() {
  const { user, logout } = useAuth();
  const { getTotalItems } = useCartStore();
  const navigate = useNavigate();
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const checkAdminStatus = async () => {
      if (!user) {
        setIsAdmin(false);
        return;
      }

      try {
        const { data: profile } = await supabase
          .from('profiles')
          .select('is_admin')
          .eq('id', user.id)
          .single();

        setIsAdmin(profile?.is_admin || false);
      } catch (error) {
        console.error('관리자 권한 확인 오류:', error);
        setIsAdmin(false);
      }
    };

    checkAdminStatus();
  }, [user]);

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/');
    } catch (error) {
      console.error('로그아웃 오류:', error);
    }
  };

  return (
    <header className="bg-white shadow-sm border-b border-gray-200 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* 로고 */}
          <Link to="/" className="flex items-center gap-3 cursor-pointer hover:opacity-80 transition-opacity">
            <div className="flex items-center gap-2">
              <span className="text-4xl font-black text-orange-600" style={{ fontFamily: "'Pacifico', cursive" }}>쿨팡</span>
              <div className="w-8 h-8 bg-gradient-to-r from-orange-500 to-orange-600 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-lg">정</span>
              </div>
              <span className="text-xl font-bold text-gray-900">정희네농원</span>
            </div>
          </Link>

          {/* 네비게이션 */}
          <nav className="hidden md:flex items-center gap-8">
            <Link 
              to="/" 
              className="text-gray-700 hover:text-orange-600 font-medium transition-colors cursor-pointer"
            >
              홈
            </Link>
            <Link 
              to="/products" 
              className="text-gray-700 hover:text-orange-600 font-medium transition-colors cursor-pointer"
            >
              상품
            </Link>
            <Link 
              to="/cart" 
              className="text-gray-700 hover:text-orange-600 font-medium transition-colors cursor-pointer relative"
            >
              장바구니
              {getTotalItems() > 0 && (
                <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
                  {getTotalItems()}
                </span>
              )}
            </Link>
          </nav>

          {/* 사용자 메뉴 */}
          <div className="flex items-center gap-4">
            {user ? (
              <div className="flex items-center gap-3">
                {isAdmin && (
                  <Link
                    to="/admin/dashboard"
                    className="bg-red-600 hover:bg-red-700 text-white px-3 py-1.5 rounded-lg text-sm font-semibold transition-colors cursor-pointer flex items-center gap-1 whitespace-nowrap"
                  >
                    <i className="ri-shield-star-line"></i>
                    관리자
                  </Link>
                )}
                <Link
                  to="/mypage"
                  className="text-gray-700 hover:text-orange-600 font-medium transition-colors cursor-pointer whitespace-nowrap"
                >
                  마이페이지
                </Link>
                <button
                  onClick={handleLogout}
                  className="text-gray-700 hover:text-red-600 font-medium transition-colors cursor-pointer whitespace-nowrap"
                >
                  로그아웃
                </button>
              </div>
            ) : (
              <div className="flex items-center gap-3">
                <Link
                  to="/auth/login"
                  className="text-gray-700 hover:text-orange-600 font-medium transition-colors cursor-pointer whitespace-nowrap"
                >
                  로그인
                </Link>
                <Link
                  to="/auth/register"
                  className="bg-orange-600 hover:bg-orange-700 text-white px-4 py-2 rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap"
                >
                  회원가입
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}
